/****************************************************
 * Module Name:  permissionProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class PermissionProxy {
  static GetAllPermission = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllPermissionMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSinglePermission = (permissionId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/permission/${permissionId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckPermissionAvailable = (permission, callback) => {
    let params = {
      permission: permission,
    };

    restAPICall(
      Constants.MANAGER_URL + "/permission/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddPermission = (permission, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(permission),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePermission = (permission, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(permission),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
